<!-- This example requires Tailwind CSS v2.0+ -->
<div class="flow-root">
  <ul class="divide-y divide-gray-200">
    <ng-content select="[confect-accordion-item]" />
  </ul>
</div>
